import React from "react";
import { Box, CssBaseline, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";
import Navbar from "../../component/organisms/layoutComponent/Navbar";
import Sidebar from "../../component/organisms/layoutComponent/Sidebar";
// import Breadcrumbs from "../../component/atoms/Breadcrumbs";
import { useSidebar } from "../../hooks/useSidebar";

const FULL_DRAWER_WIDTH = 280;
const COLLAPSED_DRAWER_WIDTH = 73;
const NAVBAR_HEIGHT = 64; // Match the navbar height

const AdminLayout: React.FC = () => {
  const isMobile = useMediaQuery("(max-width:1199px)");
  const {
    collapsed,
    mobileOpen,
    toggleCollapsed,
    toggleMobile,
    closeMobile,
  } = useSidebar();

  const handleDrawerToggle = () => {
    if (isMobile) {
      toggleMobile();
    } else {
      toggleCollapsed();
    }
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", width: "100%" }}>
      <CssBaseline />
      
      {/* Sticky Navbar */}
      <Navbar onDrawerToggle={handleDrawerToggle} />

      {/* Sidebar */}
      <Sidebar
        open={mobileOpen || !isMobile}
        onClose={closeMobile}
        collapsed={!mobileOpen && !isMobile && collapsed}
      />

      {/* Main Content Area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          minHeight: "calc(100vh - 64px)",
          width: "100%",
          pt: `${NAVBAR_HEIGHT}px`, // Account for fixed navbar
          pl: isMobile
            ? 0
            : `${collapsed ? COLLAPSED_DRAWER_WIDTH : FULL_DRAWER_WIDTH}px`,
          transition: "margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          backgroundColor: (theme) => theme.palette.background.default,
          // Ensure content doesn't overflow on mobile
          maxWidth: isMobile ? "100vw" : "none",
          overflow: isMobile ? "hidden" : "auto",
        }}
      >
        {/* Scrollable Content Container */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden", // Prevent body scroll
            // Mobile-specific adjustments
            ...(isMobile && {
              width: "100%",
              maxWidth: "100vw",
            }),
          }}
        >
          {/* Content with Scroll */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              overflowX: "hidden",
              p: { xs: 1, sm: 2, md: 3 },
            }}
          >
            {/* <Breadcrumbs /> */}
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AdminLayout;
